module.exports = __webpack_public_path__ + "media/images/hybrid-raid-manager-screenshot-3-2336e95decf7db1b64345055a077ad78.jpg";